import React from 'react'
import { Routes, Route, useSearchParams } from 'react-router'
import { HomePage, LoginPage, LogoutPage, ForgotPasswordPage, ResetPasswordPage, ProviderRegistrationPage, DieticianRegistrationPage, EditDieticianProfilePage, ProviderDashboardPage, DashboardPage, ReferralWorkflowPage, NotFoundPage, TermsAndConditionsPage, PrivacyPolicyPage, AboutUsPage, PatientRegistrationPage, EditPatientProfilePage, ReferralLandingPage, ReferralDetailsPage, DieticianReferralDetailsPage, MealPlanListPage, CreateMealPlanPage, MealPlanDetailsPage, SelfReferralLandingPage, DirectBookingWizard, ShoppingListPage, OtpPage } from '@/components/pages'
import { AuthenticatedRoute, UnauthenticatedRoute } from '@/components/auth'
import EditProviderProfilePage from './components/pages/EditProviderProfilePage'

// ReferralDetails wrapper component to extract referralId from URL params
const ReferralDetailsWrapper: React.FC = () => {
  const [searchParams] = useSearchParams();
  const referralId = searchParams.get('id') || '';

  return <ReferralDetailsPage referralId={referralId} />;
};

function App() {
  return (
    <Routes>
      <Route path="/" element={
        <HomePage/>
      } />
      <Route path="/logout" element={<LogoutPage />} />
      <Route path="/login" element={
        <UnauthenticatedRoute>
          <LoginPage />
        </UnauthenticatedRoute>
      } />
      <Route path="/forgot-password" element={
        <UnauthenticatedRoute>
          <ForgotPasswordPage />
        </UnauthenticatedRoute>
      } />
      <Route path="/auth/reset-password" element={
        <UnauthenticatedRoute>
          <ResetPasswordPage />
        </UnauthenticatedRoute>
      } />
      <Route path="/otp" element={
        <AuthenticatedRoute>
          <OtpPage />
        </AuthenticatedRoute>
      } />
      <Route path="/provider/register" element={
        <ProviderRegistrationPage />
      } />
      <Route path="/dietitian/register" element={
        <DieticianRegistrationPage />
      } />
      <Route path="/patient/register" element={
        <PatientRegistrationPage />
      } />
      <Route path="/dietitian/edit-profile" element={
        <AuthenticatedRoute>
          <EditDieticianProfilePage />
        </AuthenticatedRoute>
      } />
      <Route path="/dietitian/referral/:referralId" element={
        <AuthenticatedRoute>
          <DieticianReferralDetailsPage />
        </AuthenticatedRoute>
      } />
      <Route path="/patient/edit-profile" element={
        <AuthenticatedRoute>
          <EditPatientProfilePage />
        </AuthenticatedRoute>
      } />
      <Route path="/provider/edit-profile" element={
        <AuthenticatedRoute>
          <EditProviderProfilePage />
        </AuthenticatedRoute>
      } />
      <Route path="/dashboard" element={<DashboardPage />} />
      <Route path="/provider/dashboard" element={
        <AuthenticatedRoute>
          <ProviderDashboardPage />
        </AuthenticatedRoute>
      } />
      <Route path="/referral-workflow" element={
        <AuthenticatedRoute>
          <ReferralWorkflowPage />
        </AuthenticatedRoute>
      } />
      <Route path="/referral-details" element={
        <AuthenticatedRoute>
          <ReferralDetailsWrapper />
        </AuthenticatedRoute>
      } />
      <Route path="/meal-plans" element={
        <AuthenticatedRoute>
          <MealPlanListPage />
        </AuthenticatedRoute>
      } />
      <Route path="/meal-plans/create" element={
        <AuthenticatedRoute>
          <CreateMealPlanPage />
        </AuthenticatedRoute>
      } />
      <Route path="/meal-plan/:id" element={
        <AuthenticatedRoute>
          <MealPlanDetailsPage />
        </AuthenticatedRoute>
      } />
      <Route path="/shopping-list" element={
        <AuthenticatedRoute>
          <ShoppingListPage />
        </AuthenticatedRoute>
      } />
      <Route path="/terms" element={
        <TermsAndConditionsPage />
      } />
      <Route path="/privacy" element={
        <PrivacyPolicyPage />
      } />
      <Route path="/about" element={
        <AboutUsPage />
      } />
      <Route path="/referral/:token" element={
        <ReferralLandingPage />
      } />
      <Route path="/referral/self-serve/:providerId" element={
        <SelfReferralLandingPage />
      } />
      <Route path="/referral/self-referral/:providerId" element={
        <SelfReferralLandingPage />
      } />
      <Route path="/referral/direct/:dietitianId" element={
        <DirectBookingWizard />
      } />
      <Route path="/auth/mfa" element={
        <AuthenticatedRoute>
          <OtpPage />
        </AuthenticatedRoute>
      } />
      <Route path="*" element={
        <NotFoundPage />
      } />
    </Routes>
  )
}

export default App
